// src/branding.js
//
// Live proxy over ThemeContext's brand tokens — NOT a second hardcoded copy.
// primaryBlue/logoYellow read the same tenant-configured colors (from
// GET /config/, applied by ThemeContext.setBrandColors) that ThemeContext's
// own T.blue/T.yellow use, so there is exactly one source of truth for the
// brand palette even though this older import path is still used by many
// components. Getters keep every read live, including on the derived Fonts
// object below.
import { getBrandColors } from "./ThemeContext";

export const Colors = {
  get primaryBlue() { return getBrandColors().blue; },
  get accentBlue()  { return getBrandColors().blueDark; },
  get logoYellow()  { return getBrandColors().yellow; },
  get success()     { return getBrandColors().green; },
  get danger()      { return getBrandColors().red; },
  get warning()     { return getBrandColors().orange; },
  lightGray: "#f5f5f5",
  white: "#ffffff",
  textDark: "#222222",
  iconGray: "#888888",
  inputBackground: "#ffffff",
};

export const Shadows = {
  card: "0 8px 30px rgba(0,0,0,0.15)",
  soft: "0 4px 12px rgba(0,0,0,0.10)",
};

export const Radii = {
  small: "6px",
  medium: "10px",
  large: "16px",
};

export const Fonts = {
  title: {
    fontSize: "28px",
    fontWeight: "700",
    get color() { return getBrandColors().blue; },
  },
  sectionTitle: {
    fontSize: "22px",
    fontWeight: "700",
    get color() { return getBrandColors().blue; },
  },
  label: {
    fontWeight: "600",
    get color() { return getBrandColors().blue; },
  },
};

export const Layout = {
  page: {
    background: "linear-gradient(135deg, #e3f2fd, #fce4ec)",
    minHeight: "100dvh",
    padding: "30px",
    display: "flex",
    justifyContent: "center",
  },
  card: {
    width: "1200px",
    background: Colors.white,
    padding: "30px",
    borderRadius: Radii.large,
    boxShadow: Shadows.card,
  },
};

export const FieldWidths = {
  formField: "600px",   // consistent width for search, comments, login ID
};
